export default "__VITE_ASSET__DGt0Bo9p__"